import HeroSection from '@/components/HeroSection'
import ServiceDescription from '@/components/ServiceDescription'
import BotAccess from '@/components/BotAccess'
import FAQ from '@/components/FAQ'
import Footer from '@/components/Footer'

function App() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-green-50">
      <HeroSection />
      <ServiceDescription />
      <BotAccess />
      <FAQ />
      <Footer />
    </div>
  )
}

export default App